import { render, staticRenderFns } from "./Bots.vue?vue&type=template&id=f7a29350&scoped=true&"
import script from "./Bots.vue?vue&type=script&lang=js&"
export * from "./Bots.vue?vue&type=script&lang=js&"
import style0 from "./Bots.vue?vue&type=style&index=0&id=f7a29350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a29350",
  null
  
)

export default component.exports